import React, { ReactElement, useEffect, useRef } from "react";
import { StyleSheet, View, ScrollView, Platform } from "react-native";
import variables from "../../styles/variables";
import Footer from "../Footer";
import { LambdatestScrollOverlay } from "../LambdatestScrollOverlay";
import { useAtom } from "jotai";
import { appScrollRefAtom2 } from "../../atoms";
import { APP_ENV } from "../../client";

export type HomepageLayoutProps = {
  content: ReactElement;
};

const Wrapper = ({ children }) => {
  const appScrollRef2 = useRef<ScrollView>(undefined);
  const [, setAppScrollRef2] = useAtom(appScrollRefAtom2);

  useEffect(() => {
    if (Platform.OS == "web") return;
    if (appScrollRef2?.current) setAppScrollRef2(appScrollRef2);
  }, [appScrollRef2]);

  return Platform.OS == "web" ? (
    <View style={styles.webContainer}>{children}</View>
  ) : (
    <ScrollView
      accessibilityLabel="Scroll Bar"
      style={{ backgroundColor: colors.palette.rtv.primary }}
      ref={appScrollRef2}
    >
      {children}
      {APP_ENV === "integration" && <LambdatestScrollOverlay />}
    </ScrollView>
  );
};

export const HomepageLayout = ({ content }: HomepageLayoutProps) => {
  return (
    <>
      <Wrapper>
        <View style={styles.contentContainer}>{content}</View>
      </Wrapper>
      {Platform.OS == "web" ? <Footer /> : null}
      {Platform.OS === "web" && APP_ENV === "integration" && (
        <LambdatestScrollOverlay />
      )}
    </>
  );
};

const { colors } = variables;

const styles = StyleSheet.create({
  webContainer: {
    width: "100%",
    flexDirection: "row",
    height: "auto",
    backgroundColor: colors.palette.rtv.primary,
    minHeight: 600,
  },
  contentContainer: {
    backgroundColor: colors.palette.rtv.primary,
    height: "100%",
    maxWidth: "100%",
    minWidth: "100%",
    minHeight: 1300,
  },
});

export default React.memo(HomepageLayout);
